export default __webpack_public_path__ + "static/media/blueClock.001264e7.svg";